import { rateTableSchema } from "@redotech/redo-model/rate-table/rate-table";
import * as z from "zod";

export const getTeamRateTables = {
  name: "getTeamRateTables" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ rateTables: z.array(rateTableSchema) }),
};
